import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { NotificationIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons';
import NewsService from '../../services/News';
import { NewsStyled, NavIconContainerStyled } from './styles/NewsStyled';
import News from './News';
import Panel from '../UI/Panel/Panel';

const NewsWrapper = () => {
  const isMobileDevice = useMediaQuery({
    query: '(max-device-width: 1170px)',
  });

  const [newsNotification, setNewsNotification] = useState(false);
  const [lastNewsId, setLastNewsId] = useState('');

  const fetchData = async () => {
    NewsService.getLastNews()
      .then(res => {
        if (typeof window !== 'undefined') {
          setLastNewsId(res[0].id);
          setNewsNotification(
            window.localStorage.getItem('lastNews') !== res[0].id
          );
        }
      })
      .catch(() => null);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Panel
      showClose
      title="News"
      isMobileDevice={isMobileDevice}
      activator={({ setShow }) => (
        <NewsStyled onClick={() => setShow(true)}>
          <NavIconContainerStyled newsNotification={newsNotification}>
            <NotificationIcon />
          </NavIconContainerStyled>
          <span>Notificaciones</span>
        </NewsStyled>
      )}
    >
      {() => (
        <News
          lastNewsId={lastNewsId}
          setNewsNotification={setNewsNotification}
        />
      )}
    </Panel>
  );
};

export default NewsWrapper;
